export default {
    name: 'Name der Organisation',
    contact_person_fullname: 'Vor- und Nachname der Kontaktperson der Organisation',
    street: 'Straße der Organisation',
    house_number: 'Hausnummer der Organisation',
    zipcode: 'Postleitzahl der Organisation',
    city: 'Stadt der Organisation',
    contact_person_email: 'E-Mail der Kontaktperson der Organisation',
    contact_person_phone: 'Telefonnummer der Kontaktperson der Organisation',
    carrier_type: 'Art des Trägers',
    carrier_legal_form: 'Rechtsform der Organisation',
    signature: 'Unterschrift der Organisation',
    signature_date: 'Datum der Unterschrift der Organisation',
    signer: 'Unterschreibender der Organisation'

}